/**
 * Constants for the upgrader feature
 */

/** Delay in ms before resetting hexagon after win/lose animation */
export const HEXAGON_RESET_DELAY_MS = 3000;

/** Delay in ms for refresh loading indicator */
export const REFRESH_DELAY_MS = 500;

/** Number of skin thumbnails to display in items-info component */
export const THUMBNAIL_DISPLAY_COUNT = 3;

/** Default color for skins without a color value */
export const DEFAULT_SKIN_COLOR = 'var(--gray)';

/** Sort key for skin lists */
export type SortKey = 'highest_price' | 'lowest_price';

/** Sort option configuration */
export interface SortOption {
  label: string;
  key: SortKey;
}

/** Predefined sort options for skin lists */
export const SORT_OPTIONS: SortOption[] = [
  { label: 'High to Low', key: 'highest_price' },
  { label: 'Low to High', key: 'lowest_price' },
];

/** Get the next sort option (toggles between high-to-low and low-to-high) */
export function getNextSortOption(current: SortOption): SortOption {
  return current.key === 'highest_price' ? SORT_OPTIONS[1] : SORT_OPTIONS[0];
}
